import {
	createSelector,
} from '@reduxjs/toolkit';
import {
	RootState,
} from '@stores/lpdipro/store';

export const selectAppState = (state: RootState) => state.app;

export const selectCurrentLanguage = createSelector(
	selectAppState,
	(state) => state?.localization?.actualLanguage,
);

export const selectAppNavIsOpen = createSelector(
	selectAppState,
	(state) => state?.navIsOpen ?? false,
);

export const selectIsNavOpen = (state: RootState) => {
	const display = state.device?.instance?.display as 'desktop' | 'tablet' | 'mobile' | undefined;
	if (!display) return false;
	const app = selectAppState(state) as any;
	return Boolean(app?.[display]?.navIsOpen);
};